// UserPreferences.jsx
import React, { useContext, useState,useEffect } from "react";
import axios from "axios";
import { AuthContext } from "../login/AuthContext";
import { getJwtToken, setJwtToken } from "../../utils/authUtils";

import translations from "../../utils/language/translations.json";
import { useTranslation } from "react-i18next";

export default function UserPreferences() {
  const {
    liveCsrfToken,
    preferredCatalog,
    preferredLanguage,
    setPreferredCatalog,
    setPreferredLanguage,
  } = useContext(AuthContext);

  const [saving, setSaving] = useState(false);
 const [loadingPrefs, setLoadingPrefs] = useState(true);
  const { i18n } = useTranslation();
  const currentLang = i18n.language;
  const t = (key) => translations.ProfilChoice?.[key]?.[currentLang] ?? key;

  const savePrefs = async (nextCatalog, nextLang) => {
    setSaving(true);
    try {
      const jwt = getJwtToken();

      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE}/api/user/preferences`,
        {
          preferredCatalog: nextCatalog,
          preferredLanguage: nextLang === "" ? null : nextLang,
        },
        {
          withCredentials: true,
          headers: {
            ...(liveCsrfToken ? { "x-csrf-token": liveCsrfToken } : {}),
            ...(jwt ? { Authorization: `Bearer ${jwt}` } : {}),
          },
        }
      );

      if (res.data?.success) {
        // ✅ update context
        setPreferredCatalog?.(res.data.preferredCatalog);
        setPreferredLanguage?.(res.data.preferredLanguage);

        // ✅ storage sync
        localStorage.setItem("preferredCatalog", res.data.preferredCatalog || "Hockey");
        localStorage.setItem("preferredLanguage", res.data.preferredLanguage || "");

        // ✅ si JWT refresh renvoyé, on l’enregistre (mode private / fallback)
        if (res.data?.token) setJwtToken(res.data.token);
      }
    } catch (e) {
      console.error("Could not save preferences:", {
        message: e?.message,
        status: e?.response?.status,
        data: e?.response?.data,
      });
    } finally {
      setSaving(false);
    }
  };

 useEffect(() => {
    const fetchPrefs = async () => {
      setLoadingPrefs(true);
      try {
        const jwt = getJwtToken();

        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE}/api/user/preferences`,
          {
            withCredentials: true,
            headers: {
              ...(liveCsrfToken ? { "x-csrf-token": liveCsrfToken } : {}),
              ...(jwt ? { Authorization: `Bearer ${jwt}` } : {}),
            },
          }
        );

        if (res.data?.success) {
          const nextCatalog = res.data.preferredCatalog || "Hockey";
          const nextLanguage = res.data.preferredLanguage || "";

          setPreferredCatalog?.(nextCatalog);
          setPreferredLanguage?.(nextLanguage || null);

          localStorage.setItem("preferredCatalog", nextCatalog);
          localStorage.setItem("preferredLanguage", nextLanguage);

          if (res.data?.token) setJwtToken(res.data.token);
        }
      } catch (e) {
        console.error("Could not fetch preferences:", {
          message: e?.message,
          status: e?.response?.status,
          data: e?.response?.data,
        });
      } finally {
        setLoadingPrefs(false);
      }
    };

    fetchPrefs();
  }, [liveCsrfToken, setPreferredCatalog, setPreferredLanguage]);

  return (
    <div style={{ width: "100%", maxWidth: 520 }}>
      <h2 style={{ marginBottom: 12 }}>{t("User preferences")}</h2>

      <div style={{ marginBottom: 14 }}>
        <label style={{ display: "block", marginBottom: 6 }}>
          {t("Default catalog")}
        </label>
        <select
          value={preferredCatalog}
          onChange={(e) => savePrefs(e.target.value, preferredLanguage)}
          disabled={saving}
          style={{ width: "100%", padding: 10, borderRadius: 8 }}
        >
          <option value="Hockey">Hockey</option>
          <option value="Pokemon">Pokemon</option>
          <option value="Both">{t("Both")}</option>
        </select>
      </div>

      <div style={{ marginBottom: 14 }}>
        <label style={{ display: "block", marginBottom: 6 }}>
          {t("Language")}
        </label>
        <select
          value={preferredLanguage || ""}
          onChange={(e) => savePrefs(preferredCatalog, e.target.value)}
          disabled={saving}
          style={{ width: "100%", padding: 10, borderRadius: 8 }}
        >
          <option value="en">{t("English")}</option>
          <option value="fr">Français</option>
        </select>
      </div>

      {saving ? <p>{t("Saving...")}</p> : null}
    </div>
  );
}
